/**
 * Utility functions for domain-based language detection
 */

export const getDomainLanguage = (): string => {
  if (typeof window === 'undefined') {
    return 'en'; // Default for SSR
  }

  const hostname = window.location.hostname;
  
  // Check if the domain contains 'capcam.cn' or ends with '.cn'
  if (hostname.includes('capcam.cn') || hostname.endsWith('.cn')) {
    return 'cn';
  }
  
  // Default to English for all other domains (including capcam.app)
  return 'en';
};

export const getDocumentTitle = (language: string): string => {
  return language === 'cn' ? 'CapCam 3D相机' : 'CapCam';
};

export const setDocumentTitle = (language: string): void => {
  if (typeof document !== 'undefined') {
    document.title = getDocumentTitle(language);
  }
}; 